module.exports = __webpack_public_path__ + "img/thicon.6f908a79.png";